import React from "react";
import Seo from "../components/Seo";
import { connectivityPageTplData } from "../data/page-tpl-connectivity.data";
import { getCurrentPageSeo } from "../helpers/richContentHelpers";
import { Container } from "react-bootstrap";
import Section from "../components/Section";
import Connectivity from "../components/Connectivity";
import PageHeadConnectivity from "../components/Page/PageHeadConnectivity";
import Layout from "../components/Layout";
import PageFooterSections from "../components/PageFooterSections";
import Hero from "../componentsSections/Hero";

const pageConnectivity = ({ pageContext: { id } }) => {
    const seoPageData = getCurrentPageSeo(id);
    const pageData = connectivityPageTplData(id);

    return (
        <Layout pageTitle={seoPageData.title}>
            {/* SEO Metas */}
            <Seo post={seoPageData} />

            {/* HERO */}
            <Hero {...pageData.hero} textSize="big" />
            <Section className="-small-margin-bottom "></Section>
            {/* Connectivity Section */}
            <Section>
                <Container className="container-mobile-full">
                    <PageHeadConnectivity {...pageData.pageHeader} centered />
                    <Connectivity />
                </Container>
            </Section>

            <PageFooterSections pageData={pageData} />
        </Layout>
    );
};

export default pageConnectivity;
